export default __webpack_public_path__ + "static/media/Wildcard_uncommon.dd66a064.png";